<template>
	<div class="taskGroupList" style="height: 100%">
		<el-table :data="getGroupList(taskGroupList)" @current-change="handleCurrentChange" @row-dblclick="rowDbclick" highlight-current-row :row-style="showRow" rowKey="ID" v-bind="$attrs" v-scrollBar:tableArg :height="listHeight">
			<el-table-column v-for="(column, index) in columns" :key="column.value" :label="column.text" :width="column.width">
<template slot-scope="scope">
							<div v-html="scope.row[column.value]"></div>
              </template>
			</el-table-column>
			<slot/>
		</el-table>
	<TaskDetails ref="taskDetail"></TaskDetails>
	</div>
</template>
<script>
	import treeToArray from "@/util/EvalDataToTree";
	import TaskDetails from "./TaskDetails.vue";
	import {
		mapState,
		mapActions,
		mapMutations,
		mapGetters
	} from 'vuex'
	export default {
		name: "taskGroupList",
		components: {
			TaskDetails
		},
		data() {
			return {
				resizeTimer: null, // 自适应高度的定时器
				expandAll: true, // 表格是否展开
				selectedRow: null, // 当前选择的行的数据
				listHeight: 
					document.body.clientHeight - 1600, //（这里的240是减去表格上面导航和搜索条件的高度）
				columns: [ // 列
					{
						text: "任务单号",
						value: "INSTANCE"
					},
					{
						text: "任务名称",
						value: "TASKNAME"
					},
					{
						text: "工作记录",
						value: "RecordInfo"
					}
				]
			}
		},
		computed: {

      ...mapState({
				taskGroupCurrent: state => state.task.taskGroupCurrent,
				taskGroupList: state => state.task.taskGroupList,
				taskGroupNative: state => state.task.taskGroupNative,
				taskGropuParent: state => state.task.taskGropuParent,
			}),
			formatData() {
				let tmp = this.taskGroupList;
				const func = treeToArray;
				const args = [tmp, this.expandAll];
				return func.apply(null, args);
			}
		},
		mounted() {},
		methods: {
			getNowFloor(treeData) { // 获取当前元素所在的层级。
				var _this = this;
				let floor = 0;
				let max = 0;
				function each(data, floor) {
					var arr = _this.taskGroupNative.filter((a) => {
						return a.ID == data.PARENTID
					})
					if (arr && arr.length > 0) {
						floor += 1;
						each(arr[0], floor)
					} else {
						max = floor
					}
				}
				each(treeData, 0)
				return max
			},
			RowColor(row) { // 行对应颜色
				var colorList = ["#000", "#FFB84B", "#22A1FF", "#ccc", "#E6DB74"]
				var index = this.getNowFloor(row);
				if (colorList[index]) {
					return colorList[index]
				} else {
					return "#000"
				}
			},
			showRow(row) { // 是否展示子任务
				const show = row.row.parent ?
					row.row.parent._expanded && row.row.parent._show :
					true;
				row.row._show = show;
				return show ?
					"animation:treeTableShow 1s;-webkit-animation:treeTableShow 1s;" :
					"display:none;";
			},
			toggleExpanded(trIndex) { // 切换下级是否展开
				const record = this.formatData[trIndex];
				record._expanded = !record._expanded;
			},
			taskNameClick(value, row) { // 点击单号 / 任务名称 触发
				if (value == 'TASKNAME' || value == 'INSTANCE') {
					this.$store.dispatch('changeCurTask', row);
					// this.$store.dispatch('changeTaskDetailShow', true);
					this.$refs.taskDetail.dialogVisible = true;
				}
			},
			iconShow(index, record) { // 图标显示
				return index === 0 && record.children && record.children.length > 0;
			},
			handleCurrentChange(row) { // 选中行数据
				this.$emit("changeCurTask", row);
				// this.$emit("changeCurTask", row);
			},
			rowDbclick(row, event) {
				//双击行事件
				this.$store.dispatch("changeCurTask", row);
				// this.$refs.taskDetail.dialogVisible = true;
			},
			getGroupList(items){
				items.forEach(c => {
					    if(c.RecordInfo)
						c.RecordInfo=c.RecordInfo.replace(/↵/g, "<br/>");
					});
					return items;
			}
		}
	}
</script>
<style scoped lang="less">
	@keyframes treeTableShow {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
	@-webkit-keyframes treeTableShow {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
	.sonTaskColor {
		color: #FFB84B;
	}
	.NameHighLight {
		cursor: pointer;
		color: #46A1FF;
	}
	.ms-tree-space {
		position: relative;
		top: 1px;
		display: inline-block;
		font-style: normal;
		font-weight: 400;
		line-height: 1;
		width: 18px;
		height: 14px;
	}
	.ms-tree-space::before {
		content: "";
	}
	.processContainer {
		width: 100%;
		height: 100%;
	}
	table td {
		line-height: 26px;
	}
	.tree-ctrl {
		position: relative;
		cursor: pointer;
		color: #2196f3;
		margin-left: -18px;
		margin-right: 5px;
	}
</style>
